(function () {
    'use strict';
    angular.module('emarket.store.post', [ 'ui.router' ]).config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('store.post', {
            url: '/producto/:title',
            views: {
                store: {
                    templateUrl: 'store/post/store-post.tpl.html',
                    controller: 'StorePostController as model'
                }
            }
      // resolve: {
      //   post: function ($stateParams, Post) {
      //     return Post.$find($stateParams.title).$asPromise();
      //   }
      // }
        });
    }]);
}());

(function () {
    'use strict';
    angular.module('emarket.store.post', [ 'ui.router' ]).config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('store.post', {
            url: '/producto/:title',
            views: {
                store: {
                    templateUrl: 'store/post/store-post.tpl.html',
                    controller: 'StorePostController as model'
                }
            }
      // resolve: {
      //   post: function ($stateParams, Post) {
      //     return Post.$find($stateParams.title).$asPromise();
      //   }
      // }
        });
    }]);
}());
